<template>
  <div class="popup_wrap">
    <span @click="openDetailModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="입장·체험료 할인, 면제대상 확인서">
      <div>
        <div class="inputBox tableBox mb10">
          <table>
            <colgroup>
              <col width="140px" />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tbody>
              <!-- <tr>
                <td>
                  단체명
                  <br />
                  <small>(학교, 유치원 등)</small>
                </td>
                <td colspan="3"><input type="text" v-model="orgName" disabled /></td>
                <td>예약번호</td>
                <td colspan="3"><input type="text" v-model="bundleRvNo" disabled /></td>
              </tr>
              <tr>
                <td>주소</td>
                <td colspan="7">
                  <span class="adSchbox">
                    <div class="sch mb10">
                      <input type="text" v-model="orgPostCd" placeholder="우편번호" />
                      <a class="btn" @click="postChk">주소검색</a>
                    </div>
                    <input type="text" class="wdhalf mb10" v-model="orgBasicAddress" placeholder="주소" />
                    <input type="text" class="wdhalf" v-model="orgEtcAddress" maxlength="100" placeholder="상세주소" />
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  인솔자
                  <br />
                  <small>(예약자)</small>
                </td>
                <td colspan="3">
                  <span><input type="text" v-model="writerName" disabled /></span>
                </td>
                <td>전화번호</td>
                <td colspan="3">
                  <span><input type="text" v-model="writerMobile" placeholder="(휴대폰)" disabled /></span>
                </td>
              </tr> -->
              <!-- <tr>
                <td rowspan="2">
                  인솔자
                  <br />
                  <small>(예약자)</small>
                </td>
                <td rowspan="2" colspan="3">
                  <span><input type="text" v-model="writerName" disabled /></span>
                </td>
                <td rowspan="2">전화번호</td>
                <td colspan="3">
                  <span><input type="text" v-model="writerOrgPhone" placeholder="(근무처)" /></span>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span><input type="text" v-model="writerMobile" placeholder="(휴대폰)" disabled /></span>
                </td>
              </tr> -->
              <tr>
                <td>
                  단체명
                  <br />
                  <small>(학교, 유치원 등)</small>
                </td>
                <td colspan="3">{{ orgName }}</td>
                <td>예약번호</td>
                <td colspan="3">{{ bundleRvNo }}</td>
              </tr>
              <tr>
                <td>주소</td>
                <td colspan="7">
                  <span class="adSchbox">
                    {{ orgPostCd }}
                    &nbsp;
                    {{ orgBasicAddress }}
                    &nbsp;
                    {{ orgEtcAddress }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  인솔자
                  <br />
                  <small>(예약자)</small>
                </td>
                <td colspan="3">
                  <span>{{ writerName }}</span>
                </td>
                <td>전화번호</td>
                <td colspan="3">
                  <span>{{ writerMobile || '(휴대전화)' }}</span>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  할인(50%)대상
                  <br />
                  <small>(장애인, 국가유공자녀)</small>
                </td>
                <td rowspan="2">초등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td>4학년</td>
                <td>5학년</td>
                <td>6학년</td>
              </tr>
              <tr>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_1" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_2" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_3" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_4" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_5" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_6" />
                  </span>
                </td>
              </tr>
              <tr>
                <td rowspan="2">중·고등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td rowspan="2">
                  기타
                  <br />
                  <small>(유치원 등)</small>
                </td>
                <td rowspan="2" colspan="2">
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_7" />
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_8" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_9" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="discount cnt" type="text" v-model.number="dc_10" />
                  </span>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  면제(100%)대상
                  <br />
                  <small>(기초생활수급자녀)</small>
                </td>
                <td rowspan="2">초등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td>4학년</td>
                <td>5학년</td>
                <td>6학년</td>
              </tr>
              <tr>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_1" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_2" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_3" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_4" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_5" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_6" />
                  </span>
                </td>
              </tr>
              <tr>
                <td rowspan="2">중·고등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td rowspan="2">
                  기타
                  <br />
                  <small>(유치원 등)</small>
                </td>
                <td rowspan="2" colspan="2">
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_7" />
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_8" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_9" />
                  </span>
                </td>
                <td>
                  <span class="cnt-wrap">
                    <input class="exemtion cnt" type="text" v-model.number="ex_10" />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="signbox mb50">
          <br />
          <p class="sign1">
            <span>{{ orgName }}</span>
            &nbsp;
            <span>인솔자</span>
            &nbsp;
            <span>{{ writerName }}</span>
          </p>
          <br />
          <p class="sign1">본인은 한국잡월드 입장·체험료 할인, 면제 대상자가</p>
          <p class="sign1">
            <b>[할인 총 {{ totDcPcnt }}명], [면제 총 {{ totExPcnt }}명]</b>
            임을 위와 같이 확인합니다.
          </p>
          <br />
          <p class="sign1">{{ d_year }}년 &nbsp;{{ d_month }}월 &nbsp;{{ d_day }}일</p>
          <br />
          <p class="sign3">한국잡월드 이사장 귀하</p>
        </div>
      </div>
      <template slot="footer">
        <div class="btn_area btn_wrap">
          <a class="btn btn_bg color btn_popup left" @click="saveVerification">저장</a>
          <a class="btn btn_bg gray right" @click="closeModal">닫기</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import api from '@/api/api_config';
import { mapActions } from 'vuex';
import { isLoggedIn, gfn_popup } from '@/utils/reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';

export default {
  components: { Modal, TabItem },
  props: {
    bundleRvNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modal: {
        open: false,
      },
      resultList: [],
      writerName: '',
      writerOrgPhone: '',
      writerMobile: '',
      orgName: '',
      orgPostCd: '',
      orgBasicAddress: '',
      orgEtcAddress: '',
      dc_tot: 0,
      dc_1: 0,
      dc_2: 0,
      dc_3: 0,
      dc_4: 0,
      dc_5: 0,
      dc_6: 0,
      dc_7: 0,
      dc_8: 0,
      dc_9: 0,
      dc_10: 0,
      ex_tot: 0,
      ex_1: 0,
      ex_2: 0,
      ex_3: 0,
      ex_4: 0,
      ex_5: 0,
      ex_6: 0,
      ex_7: 0,
      ex_8: 0,
      ex_9: 0,
      ex_10: 0,
      d_year: '',
      d_month: '',
      d_day: '',
    };
  },
  computed: {
    totExPcnt() {
      this.ex_tot = this.ex_1 + this.ex_2 + this.ex_3 + this.ex_4 + this.ex_5 + this.ex_6 + this.ex_7 + this.ex_8 + this.ex_9 + this.ex_10;
      return this.ex_tot;
    },
    totDcPcnt() {
      this.dc_tot = this.dc_1 + this.dc_2 + this.dc_3 + this.dc_4 + this.dc_5 + this.dc_6 + this.dc_7 + this.dc_8 + this.dc_9 + this.dc_10;
      return this.dc_tot;
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadVerificationData();
      }
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    openEdit() {
      this.modal.open = true;
    },
    openDetailModal() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    jusoCallBack(roadFullAddr, roadAddrPart1, addrDetail, roadAddrPart2, engAddr, jibunAddr, zipNo, admCd, rnMgtSn, bdMgtSn) {
      this.orgBasicAddress = addrDetail;
      this.orgEtcAddress = roadAddrPart1 + roadAddrPart2;
      this.orgPostCd = zipNo;
    },
    postChk() {
      if (!window.jusoCallBack) {
        window.jusoCallBack = this.jusoCallBack;
      }
      gfn_popup('/registerJusoPopup.do', '570', '420', '우편번호검색');
    },
    async loadVerificationData() {
      const param = {
        bundleRvNo: this.bundleRvNo,
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      try {
        const result = await api.post('/api/reservation/' + this.bundleRvNo + '/verification', form);
        if (result.data.success) {
          const response = result.data.response;
          let data = response.verification;
          if (data) {
            this.writerName = data.writer_name || data.user_name;
            this.writerOrgPhone = data.writer_org_phone;
            this.writerMobile = data.writer_mobile || data.user_mobile_num;
            this.orgName = data.ev_org_name || data.org_name;
            this.orgPostCd = data.org_post_cd || data.post_code;
            this.orgBasicAddress = data.org_basic_address || data.basic_address;
            this.orgEtcAddress = data.org_etc_address || data.etc_address;
            this.dc_1 = data.dc_1 || 0;
            this.dc_2 = data.dc_2 || 0;
            this.dc_3 = data.dc_3 || 0;
            this.dc_4 = data.dc_4 || 0;
            this.dc_5 = data.dc_5 || 0;
            this.dc_6 = data.dc_6 || 0;
            this.dc_7 = data.dc_7 || 0;
            this.dc_8 = data.dc_8 || 0;
            this.dc_9 = data.dc_9 || 0;
            this.dc_10 = data.dc_10 || 0;
            this.ex_1 = data.ex_1 || 0;
            this.ex_2 = data.ex_2 || 0;
            this.ex_3 = data.ex_3 || 0;
            this.ex_4 = data.ex_4 || 0;
            this.ex_5 = data.ex_5 || 0;
            this.ex_6 = data.ex_6 || 0;
            this.ex_7 = data.ex_7 || 0;
            this.ex_8 = data.ex_8 || 0;
            this.ex_9 = data.ex_9 || 0;
            this.ex_10 = data.ex_10 || 0;
            const today = new Date();
            this.d_year = data.reg_year || today.getFullYear();
            this.d_month = data.reg_month || today.getMonth() + 1;
            this.d_day = data.reg_day || today.getDate();
          } else {
            alert('오류가 발생했습니다.');
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveVerification() {
      if (this.ex_tot === 0 && this.dc_tot === 0) {
        alert('할인, 면제대상을 확인해 주세요.');
        return false;
      }
      const param = {
        bundleRvNo: this.bundleRvNo,
        writerName: this.writerName || '',
        writerOrgPhone: this.writerOrgPhone || '',
        writerMobile: this.writerMobile || '',
        orgName: this.orgName || '',
        orgPostCd: this.orgPostCd || '',
        orgBasicAddress: this.orgBasicAddress || '',
        orgEtcAddress: this.orgEtcAddress || '',
        dc_1: this.dc_1,
        dc_2: this.dc_2,
        dc_3: this.dc_3,
        dc_4: this.dc_4,
        dc_5: this.dc_5,
        dc_6: this.dc_6,
        dc_7: this.dc_7,
        dc_8: this.dc_8,
        dc_9: this.dc_9,
        dc_10: this.dc_10,
        ex_1: this.ex_1,
        ex_2: this.ex_2,
        ex_3: this.ex_3,
        ex_4: this.ex_4,
        ex_5: this.ex_5,
        ex_6: this.ex_6,
        ex_7: this.ex_7,
        ex_8: this.ex_8,
        ex_9: this.ex_9,
        ex_10: this.ex_10,
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      customConfirm('저장 하시겠습니까?', async (confirm) => {
        if (confirm) {
          try {
            const result = await api.post('/api/resvr/mergeVerification', form);
            alert(result.data.response.resulMsg);
          } catch (e) {
            console.log(e);
          }
          location.reload();
        }
      });
    },
  },
  created() {},
  destroyed() {
    if (window.jusoCallBack) {
      window.jusoCallBack = undefined;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .pop_layer {
  min-width: 1024px;
  left: calc(50% - 500px);
  margin-left: 0;
}
.pop_layer {
  & .tableBox {
    overflow: auto;
    text-align: center;
    border: inherit;
  }
  & input {
    width: 100%;
  }

  & .cnt-wrap {
    position: relative;
    display: inline-block;

    & input {
      width: 100%;
      padding-right: 1.5rem;
    }
  }
  & .cnt-wrap::after {
    content: '명';
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: grey;
    font-size: 14px;
  }

  & .signbox {
    & .sign1 {
      text-align: center;
    }
  }
}
@media all and (max-width: 1024px) {
  ::v-deep .pop_layer {
    min-width: 100%;
    left: 0;
  }
}
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
}
</style>
